import styled from "styled-components";
import { hexToRGB } from "../../../Utils/font";

export const _EmailRegisterRoot = styled("div")<{}>(() => {
  return {
    borderBottom: `1px solid ${hexToRGB("#666666", 0.5)}`,
    display: "flex",
    minHeight: 34,
  };
});

export const _EmailRegisterInput = styled("input")<{}>(() => {
  return {
    backgroundColor: "transparent",
    border: "none",
    outline: "none",
    fontSize: "inherit",
    color: "inherit",
    width: "100%",
  };
});
